module.exports = __webpack_public_path__ + "img/p12.d0379781.png";